import React from "react"

import {Typography} from "antd";

import EventSection2 from "../theme/components/event2";
import {fetchEvents} from "../../../services/EventService";

const {Text}=Typography

export default class EventRender extends React.Component{

    state = { events: [], eventGroupes: [], loading: true }

    componentDidMount() {
        const org = this.props.context?.org
        if (org) fetchEvents(org.id, {virtualId: org.virtualId || null}).then(d => this.setState({ events: d.events, eventGroupes: d.eventGroupes, loading: false }))
        else this.setState({ loading: false })
    }

    getEvents()
    {
      // Événements issus de /v1/events (fetch client), plus de org.events.
      const events = this.state.events

      if(!Array.isArray(events)){
        return []
      }

      var date=new Date()
      date.setHours(0,0,0)

        return events.filter((i)=>new Date(i.dateEvent)>=date).sort((a,b)=>{
            var datea=new Date(a.dateEvent)
            var dateb=new Date(b.dateEvent)
            if(datea==dateb){
                return 0
            }
            return datea>dateb?1:-1
        })
    }

    render()
    {
        const context=this.props.context
        const {org}=context

        var events=this.getEvents()

        return (
            <EventSection2 context={context} events={events} EventClass={'wpo-event-area-2'}/>
        )
    }
}

/*

*/
